import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import Modal from '@material-ui/core/Modal';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import UpdateIcon from '@material-ui/icons/Update';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import 'moment/locale/pt-br';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import { formatMoney } from '../../utils/common';

const useStyles = (theme) => ({
  root: {
    overflow: 'auto',
  },
  button: {
    margin: theme.spacing(1),
  },
  selectTipo: {
    width: 200,
  },
  paper: {
    position: 'absolute',
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
});

class PlanosAssinaturasComponent extends Component {
  constructor() {
    super();
    this.axios = instanceAxios(localStorage.getItem('toobiauth'));
    moment.locale('pt-br');
  }

  state = {
    planos: [],
    plano: {},
    columns: [
      { id: 'status', label: 'Status', minWidth: 70 },
      { id: 'nome', label: 'Nome', minWidth: 140 },
      { id: 'valor', label: 'Valor', minWidth: 140 },
      { id: 'intervalo', label: 'Intervalo', minWidth: 140 },
      { id: 'editar', label: '', minWidth: 140 },
      { id: 'status', label: '', minWidth: 140 },
    ],
    openErro: false,
    openWarning: false,
    openWarningValid: false,
    openSucess: false,
    openModal: false,
    ready: false,
  };

  UNSAFE_componentWillMount() {
    this.axios
      .get(`${environment}/listarPlanos`)
      .then((res) => {
        const planos = res.data;
        this.setState({ planos });
        this.setState({ ready: true });
      })
      .catch((err) => {
        this.setState({ openError: true });
        this.setState({ ready: true });
      });
  }

  handleClickAtualizar = async (event) => {
    this.setState({ planos: [] });
    this.setState({ ready: false });
    await this.axios
      .get(`${environment}/listarPlanos`)
      .then((res) => {
        const planos = res.data;
        this.setState({ planos });
        this.setState({ ready: true });
      })
      .catch((err) => {
        this.setState({ openError: true });
        this.setState({ ready: true });
      });
  };

  clickAlert = () => {
    this.setState({ openError: false });
    this.setState({ openSucess: false });
    this.setState({ openWarning: false });
    this.setState({ openWarningValid: false });
  };

  handleClose = () => {
    this.clickAlert();
    this.setState({ plano: {} });
    this.setState({ openModal: false });
  };

  handleOpenModal = (plano) => {
    plano.valor /= 100;
    this.clickAlert();
    this.setState({ plano });
    this.setState({ openModal: true });
  };

  handleClickSave = () => {
    // Checando se todos dados estão presentes
    if (
      !this.state.plano.nome ||
      !this.state.plano.valor ||
      !this.state.plano.interval ||
      !this.state.plano.interval_type
    ) {
      this.setState({ openWarningValid: true });
      return;
    }
    // tratando objeto
    const { plano } = this.state;
    plano.identificador_iugu = plano.nome.replace(' ', '_');
    plano.valor *= 100;
    if (this.state.plano.id) {
      this.handleEditarPlano(plano);
    } else {
      this.handleCriarPlano(plano);
    }
  };

  handleEditarPlano = (plano) => {
    this.axios
      .put(`${environment}/editarPlano`, plano)
      .then(async (resp) => {
        await this.handleClickAtualizar();
        this.setState({ openSucess: true });
        this.setState({ openModal: false });
        this.setState({ ready: true });
      })
      .catch((err) => {
        this.setState({ openError: true });
        this.setState({ openModal: false });
        this.setState({ ready: true });
      });
  };

  handleCriarPlano = (plano) => {
    this.axios
      .post(`${environment}/criarPlano`, plano)
      .then(async (resp) => {
        await this.handleClickAtualizar();
        this.setState({ openSucess: true });
        this.setState({ openModal: false });
        this.setState({ ready: true });
      })
      .catch((err) => {
        this.setState({ openError: true });
        this.setState({ openModal: false });
        this.setState({ ready: true });
      });
  };

  handleAtivar = (idPlano) => {
    this.setState({ ready: false });
    this.axios
      .get(`${environment}/ativarPlano/${idPlano}`)
      .then(async (resp) => {
        await this.handleClickAtualizar();
        this.setState({ openSucess: true });
        this.setState({ ready: true });
      })
      .catch((err) => {
        this.setState({ openError: true });
        this.setState({ ready: true });
      });
  };

  handleDesativar = (idPlano) => {
    this.setState({ ready: false });
    this.axios
      .get(`${environment}/desativarPlano/${idPlano}`)
      .then(async (resp) => {
        await this.handleClickAtualizar();
        this.setState({ openSucess: true });
        this.setState({ ready: true });
      })
      .catch((err) => {
        this.setState({ openError: true });
        this.setState({ ready: true });
      });
  };

  render() {
    const { classes } = this.props;
    return (
      <div style={{ margin: 20 }}>
        <Collapse in={this.state.openError}>
          <Alert severity="error" onClick={this.clickAlert}>
            Erro realizar ação,tente mais tarde!
          </Alert>
        </Collapse>
        <Collapse in={this.state.openSucess}>
          <Alert severity="success" onClick={this.clickAlert}>
            Ação realizada Com Sucesso!
          </Alert>
        </Collapse>
        <Collapse in={this.state.openWarning}>
          <Alert severity="Warning" onClick={this.clickAlert}>
            Aguarde!
          </Alert>
        </Collapse>
        <h1 style={{ textAlign: 'center' }}>Planos de Assinaturas</h1>
        <Grid container style={{ paddingBottom: '2%' }}>
          <Grid item xs={6}>
            <Button
              variant="contained"
              style={{
                backgroundColor: XMEI_PRIMARY_COLOR,
                color: '#FFF',
              }}
              startIcon={<UpdateIcon />}
              onClick={this.handleClickAtualizar}
            >
              Atualizar
            </Button>
          </Grid>
          <Grid item xs={6}>
            <div align="right">
              <Button
                variant="contained"
                startIcon={<AddCircleIcon />}
                style={{
                  backgroundColor: XMEI_PRIMARY_COLOR,
                  color: '#FFF',
                }}
                onClick={() => this.handleOpenModal({})}
              >
                Novo
              </Button>
            </div>
          </Grid>
        </Grid>
        <Paper className={classes.root}>
          <Collapse in={this.state.ready}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {this.state.columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.planos.map((p) => {
                  const colorChip =
                    p.status === 'Ativo' ? 'default' : 'secondary';
                  const frequencia =
                    p.interval_type === 'months' ? 'Mensal' : 'Semanal';
                  return (
                    <TableRow key={p.id}>
                      <TableCell component="th" scope="row">
                        <Chip label={p.status} color={colorChip} />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {p.nome}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {formatMoney(p.valor / 100)}
                      </TableCell>

                      <TableCell component="th" scope="row">
                        {frequencia}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Button
                          size="small"
                          variant="contained"
                          style={{
                            backgroundColor: XMEI_PRIMARY_COLOR,
                            color: '#FFF',
                          }}
                          onClick={() => this.handleOpenModal(p)}
                          startIcon={<EditIcon />}
                        >
                          Editar
                        </Button>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Collapse in={p.status === 'Inativo'}>
                          <Button
                            size="small"
                            variant="contained"
                            color={XMEI_PRIMARY_COLOR}
                            onClick={() => this.handleAtivar(p.id)}
                            startIcon={<CheckIcon />}
                          >
                            Ativar
                          </Button>
                        </Collapse>
                        <Collapse in={p.status === 'Ativo'}>
                          <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            onClick={() => this.handleDesativar(p.id)}
                            startIcon={<CancelIcon />}
                          >
                            Desativar
                          </Button>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Collapse>
          <Collapse in={this.state.ready === false}>
            <CircularProgress className={classes.loading} />
          </Collapse>
        </Paper>

        <Modal open={this.state.openModal} onClose={this.handleClose}>
          <Grid container spacing={3} className={classes.paper}>
            <h2 style={{ paddingBottom: '5%' }}>Dados do Plano</h2>
            <Collapse in={this.state.openWarning}>
              <Alert severity="Warning" onClick={this.clickAlert}>
                Aguarde!
              </Alert>
            </Collapse>
            <Collapse in={this.state.openWarningValid}>
              <Alert severity="Warning" onClick={this.clickAlert}>
                Preencha todos os dados Necessário!
              </Alert>
            </Collapse>
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="nome"
                    label="Nome"
                    variant="outlined"
                    value={this.state.plano.nome}
                    onChange={(event) => {
                      const obj = this.state.plano;
                      obj.nome = event.target.value;
                      this.setState({ plano: obj });
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="valor"
                    label="Valor"
                    variant="outlined"
                    value={this.state.plano.valor}
                    type="number"
                    onChange={(event) => {
                      const obj = this.state.plano;
                      obj.valor = event.target.value;
                      this.setState({ plano: obj });
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    id="qtdFrequencia"
                    variant="outlined"
                    value={this.state.plano.interval}
                    label="Intervalo"
                    type="number"
                    onChange={(event) => {
                      const obj = this.state.plano;
                      obj.interval = event.target.value;
                      this.setState({ plano: obj });
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    id="frequencia"
                    variant="outlined"
                    select
                    label="Frequência"
                    value={this.state.plano.interval_type}
                    onChange={(event) => {
                      const obj = this.state.plano;
                      obj.interval_type = event.target.value;
                      this.setState({ plano: obj });
                    }}
                  >
                    <MenuItem key="months" value="months">
                      Mensal
                    </MenuItem>
                    <MenuItem key="weeks" value="weeks">
                      Semanal
                    </MenuItem>
                  </TextField>
                </Grid>
                <Grid container spacing={3} style={{ paddingTop: '5%' }}>
                  <Grid item xs={12}>
                    <div align="right">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleClickSave}
                        startIcon={<SaveIcon />}
                      >
                        Salvar
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Modal>
      </div>
    );
  }
}

export default withStyles(useStyles)(PlanosAssinaturasComponent);
